import React, { useEffect } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Grid } from '@material-ui/core';
import OperationHoursCalendar from './OperationHoursCalendar';
import TimeTable from './TimeTable';
import {
  clearForm,
  setSelectedStartDate,
  setSpecialEventRestaurantsPermissions,
} from './../../redux/actions/newOperationHoursActions';
import { getHolidays } from '../../redux/actions/holidays';
import {
  operationHoursPermission,
  otherSEPermission,
} from './constants/OperationHoursPermission';

function SingleDaySpecialEvent() {
  const dispatch: any = useDispatch();

  const { CountryId, RestaurantId } = useSelector(
    (state: RootStateOrAny) => state.RestaurantsReducer.entity,
  );

  useEffect(() => {
    return () => {
      dispatch(clearForm());
    };
  }, []);

  useEffect(() => {
    if (!RestaurantId) {
      dispatch(
        setSpecialEventRestaurantsPermissions({
          ...operationHoursPermission,
          ...otherSEPermission,
        }),
      );
      const today = moment().startOf('day');
      dispatch(setSelectedStartDate(today));
    }
  }, [dispatch, RestaurantId]);

  useEffect(() => {
    if (CountryId) {
      const today = moment().startOf('day');
      dispatch(getHolidays(CountryId)).then(() =>
        dispatch(setSelectedStartDate(today)),
      );
    }
  }, [CountryId]);

  return (
    <React.Fragment>
      <Grid item xs={9} lg={3}>
        <OperationHoursCalendar RestaurantId={RestaurantId} />
      </Grid>
      <TimeTable isRange={false} />
    </React.Fragment>
  );
}

export default SingleDaySpecialEvent;
